import { useEffect } from "react";

export function useRefreshLinkedTilesOnClick(
	clickInfo: Record<string, string>,
	handleTickerChange: (id: string, value: string) => void,
) {
	// biome-ignore lint: no need to add handleTickerChange to deps array
	useEffect(() => {
		const id = Object.keys(clickInfo)[0];
		const value = clickInfo[id];

		handleTickerChange(id, value);
	}, [clickInfo]);
}
